/**
 * Page Container Component
 * Provides consistent layout, padding, and alignment for all pages
 */

import React from 'react';
import './PageContainer.scss';

export interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  fullHeight?: boolean;
}

/**
 * PageContainer Component
 * 
 * Wraps page content with consistent spacing and alignment
 * 
 * @example
 * ```tsx
 * <PageContainer>
 *   <h1>Page Title</h1>
 *   <p>Page content</p>
 * </PageContainer>
 * ```
 */
export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  className = '',
  maxWidth = 'xl',
  padding = 'lg',
  fullHeight = false,
}) => {
  const containerClasses = [
    'page-container',
    `page-container--max-width-${maxWidth}`,
    `page-container--padding-${padding}`,
    fullHeight && 'page-container--full-height',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <div className={containerClasses}>{children}</div>;
};

export default PageContainer;

